<template>
  <div
    v-bind="$attrs"
    :class="`container-box-porcentagem pa-3 ${clickable ? 'cursor-pointer' : ''}`"
    :style="`background: ${backgroundColor ? backgroundColor : '#eee'}`"
    @click="clickable ? $emit('boxPorcentagemEmit') : ''"
    >
    <div style="display: flex; align-center: center; justify-content: space-between">
      <span class="font-size-15"><strong>{{ titulo }}</strong></span>
      <span class="font-size-16 primary--text"><strong>{{ valor }}</strong></span>      
    </div>
    <div class="line-container mt-1" style="">
      <div :style="`background-color: ${color}; width: ${porcentagem}%`"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SGPBoxPorcentagemComponent',

  props: {
    backgroundColor: {
      type: String,
      required: false,
      default: ''
    },

    titulo: {
      type: String,
      required: true,
      default: 'Titutlo do card'
    },

    valor: {
      type: String,
      required: false,
      default: null
    },

    porcentagemText: {
      type: String,
      required: false,
      default: '10%'
    },

    color: {
      type: String,
      required: false,
      default: '#DA291C'
    },

    porcentagem: {
      type: Number,
      required: false,
    },

    clickable: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {

  }
}
</script>

<style lang="scss">
.container-box-porcentagem {
  width: 100%;
  padding: 12px;
  gap: 12px;
  border-radius: 8px;

  .line-container {
    display: block;
    width: 100%;
    background-color: #D9D9D9;
    border-radius: 5px;
    height: 8px;
    overflow: hidden;

    div {
      height: 8px;
      border-radius: 8px;
    }
  }
}
</style>